import { z } from "zod";

export enum ScheduleRuleSkipReason {
    accountTypeMismatch = "account_type_mismatch",
    linkedInvoiceSchedule = "linked_invoice_schedule",
    lockedPeriod = "locked_period",
    missingTemplateAccounts = "missing_template_accounts",
    noAccrualLedger = "no_accrual_ledger",
    notMoneyIn = "not_money_in",
    notMoneyOut = "not_money_out",
    policyUnsupported = "policy_unsupported",
    templateUnavailable = "template_unavailable",
    unexpected = "unexpected",
}

/** Diff field of the transaction Activity row written for each skip. */
export const SCHEDULE_RULE_SKIP_AUDIT_FIELD = "scheduleRuleSkip";

/** Matches the Transactions `transactionIds` filter cap the toast links to. */
export const SCHEDULE_RULE_SKIPPED_TRANSACTION_IDS_LIMIT = 5000;

export const scheduleRuleSkipAuditMetadataSchema = z.object({
    ruleId: z.string(),
    templateName: z.string().nullable(),
    reason: z.nativeEnum(ScheduleRuleSkipReason),
});

export type ScheduleRuleSkipAuditMetadata = z.infer<
    typeof scheduleRuleSkipAuditMetadataSchema
>;

/**
 * Schedule counts on the rule-execution COMPLETED event. The processor adds
 * `actingUserId` so the toast reaches only the user who ran the rule.
 */
export const scheduleRuleOutcomeMetadataSchema = z.object({
    actingUserId: z.number().int(),
    scheduleCreated: z.number().int().nonnegative(),
    scheduleReplaced: z.number().int().nonnegative(),
    scheduleSkipped: z.number().int().nonnegative(),
    skippedScheduleTransactionIds: z.array(z.number().int()),
});

export type ScheduleRuleOutcomeMetadata = z.infer<
    typeof scheduleRuleOutcomeMetadataSchema
>;
